"use client";

import type React from "react";
import { Badge } from "@/components/ui/badge";
import { EmptyCell } from "@/features/candidate/components/table-cells/empty";

export interface StageBadgeProps {
  name?: string | null;
  color?: string | null;
}

export function StageBadge({ name, color }: StageBadgeProps) {
  if (!name) return <EmptyCell />;
  return (
    <Badge
      variant="linear"
      size="xs"
      style={{ "--gradient-color": color ?? "#6b7280" } as React.CSSProperties}
    >
      {name}
    </Badge>
  );
}
